<template>
    <v-dialog v-model="showDialog" max-width="900px" persistent overlay-opacity="1" overlay-color="#8A8A8A">
        <v-card class="welcome-card">
            <div class="pa-6">
                <div class="text-center mb-12">
                    <h1 class="font-roboto text-h4 plusIndigoDarken2--text mb-2">
                        {{ $t('message.welcome_title') }}
                    </h1>
                    <p class="font-roboto text-h6 font-weight-regular plusTextSecondary--text">
                        {{ $t('message.welcome_message') }}
                    </p>
                </div>

                <v-item-group v-model="selectedOption">
                    <v-container>
                        <v-row class="justify-center mb-12">
                            <v-col v-for="(option, key) in options" :key="key" cols="12" md="6" class="d-flex">
                                <v-item v-slot="{ active, toggle }" :value="key">
                                    <div class="flex-grow-1">
                                        <v-card class="d-flex justify-center fill-height align-center"
                                            :class="active ? 'card_selected' : ''" outlined :elevation="active ? 4 : 0"
                                            @click="toggle">

                                            <div class="text-center px-6 py-8">
                                                <v-img class="mb-6" height="80" :src="option.icon" contain></v-img>
                                                <div>
                                                    <div class="mb-2 text-h6"
                                                        :class="active ? 'plusIndigoDarken3--text font-roboto-semi-bold' : 'plusTextSecondary--text font-roboto-medium'">
                                                        {{ option.title }}
                                                    </div>
                                                    <div class="font-roboto  text-body-2 plusTextSecondary--text">
                                                        {{ option.description }}
                                                    </div>
                                                </div>
                                            </div>
                                        </v-card>
                                    </div>
                                </v-item>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-item-group>

                <div class="welcome-footer text-center pb-8 px-6 d-flex justify-center">
                    <v-btn color="plusIndigoDarken2" elevation="2" x-large rounded @click="handleDismiss"
                        :block="$vuetify.breakpoint.smAndDown"
                        class="px-12 rounded plusTextOnSecondary--text font-roboto-semi-bold"
                        :class="!selectedOption ? 'opacity-50' : ''" :disabled="!selectedOption">
                        {{ $t('message.welcome_continue') }}
                    </v-btn>
                </div>
            </div>

        </v-card>
    </v-dialog>
</template>

<script>
export default {
    name: "WelcomeDialog",
    props: {
        show: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            selectedOption: null,
            options: {
                startFromScratch: {
                    title: this.$t('message.welcome_start_from_scratch_title'),
                    description: this.$t('message.welcome_start_from_scratch_description'),
                    icon: require('@/assets/icons/admin+/welcome-start-scratch.svg'),
                },
                migrateFromAnotherSystem: {
                    title: this.$t('message.welcome_migrate_system_title'),
                    description: this.$t('message.welcome_migrate_system_description'),
                    icon: require('@/assets/icons/admin+/welcome-migrate-system.svg'),
                },
            },
        };
    },
    computed: {
        showDialog: {
            get() {
                return this.show;
            },
            /**
             * @param {boolean} value
             */
            set(value) {
                if (!value) {
                    this.$emit("close");
                }
            },
        },
    },
    methods: {
        handleDismiss() {
            this.$emit("close", this.selectedOption);
        },
    },
};
</script>
<style scoped>
.card_selected {
    outline: 2px solid #536DFE;
    outline-offset: -2px;
}

.v-card::before {
    opacity: 0 !important;
}
</style>
